import React from "react";
import { View, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import { tokens, sharedStyles } from "../styles";

// Front-page data row that the user explicitly asked us to preserve from
// the prototype. Renders four KPIs in a 2x2 grid with hairline dividers,
// per project/components/SummaryStats.tsx:
//
//   Total: 135        |   Assigned: 82 (61%)
//   Remaining: 53     |   DBs Filled: 4/10
//
// Remaining ticks orange when > 0 to nudge action.

const Cell = ({ label, value, valueStyle }) => (
  <View style={styles.cell}>
    <Text variant="caption_2" style={styles.label}>
      {label}
    </Text>
    <Text variant="title_16" style={[styles.value, valueStyle]}>
      {value}
    </Text>
  </View>
);

const SummaryStats = ({
  total = 0,
  assigned = 0,
  remaining = 0,
  dbsFilled = 0,
  totalDbs = 0,
}) => {
  const assignedPercent =
    Number(total) > 0
      ? Math.max(
          0,
          Math.min(100, Math.round((Number(assigned) / Number(total)) * 100)),
        )
      : 0;

  return (
    <View style={[sharedStyles.card, styles.card]}>
      <Text variant="caption_2" style={styles.heading}>
        DB Assignment Progress
      </Text>
      <View style={styles.grid}>
        <Cell label="Total" value={total} />
        <Cell label="Assigned" value={`${assigned} (${assignedPercent}%)`} />
      </View>
      <View style={[styles.grid, styles.gridSecondRow]}>
        <Cell
          label="Remaining"
          value={remaining}
          valueStyle={Number(remaining) > 0 ? { color: tokens.warning } : null}
        />
        <Cell label="DBs Filled" value={`${dbsFilled}/${totalDbs}`} />
      </View>
    </View>
  );
};

export default SummaryStats;

const styles = StyleSheet.create({
  card: { paddingVertical: tokens.spacing.large },
  heading: {
    color: tokens.textSecondary,
    fontSize: 12,
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: 0.4,
    marginBottom: tokens.spacing.medium,
  },
  grid: { flexDirection: "row" },
  gridSecondRow: {
    marginTop: tokens.spacing.medium,
    paddingTop: tokens.spacing.medium,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: tokens.borderLight,
  },
  cell: {
    flex: 1,
    paddingHorizontal: tokens.spacing.small,
  },
  label: {
    color: tokens.textSecondary,
    fontSize: 12,
    marginBottom: 2,
  },
  value: {
    color: tokens.textPrimary,
    fontSize: 16,
    fontWeight: "700",
  },
});
